module.exports = __webpack_public_path__ + "img/img2.4c063b8c.jpg";